import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CreationalPagesLayoutService {
  private readonly _onClickHeaderButton = new Subject<boolean>();
  /** Fires when the user clicks the v3 header refresh icon. Pages
   *  subscribe to this to re-fetch their data (and invalidate caches). */
  private readonly _onClickRefreshButton = new Subject<boolean>();

  private readonly _onSubmit = new Subject<boolean>();
  private readonly _onDismiss = new Subject<boolean>();
  private readonly _onDelete = new Subject<boolean>();
  public institutionId = new BehaviorSubject(null);
  public readonly headerBgConfig = new BehaviorSubject<{
    mainColor: string;
    secondaryColor: string;
    fontColor: string;
  }>({
    mainColor: '#fff',
    secondaryColor: '#fff',
    fontColor: '#000',
  });

  public readonly layoutConfig = new BehaviorSubject<{
    headerTitle: string;
    headerTitleIcon: string;
    headerButtonText?: string;
    headerButtonIcon?: string;
    headerRefreshButtonText?: string;
    showBackButton?: boolean;
    footerConfig?: {
      submitButtonText: string;
      dismissButtonText?: string;
      deleteButtonText?: string;
    };
  }>({
    headerTitle: '',
    headerTitleIcon: '',
  });

  constructor() {}

  public get onClickHeaderButton() {
    return this._onClickHeaderButton.asObservable();
  }

  public set triggerClickHeaderButton(value: boolean) {
    if (value === true) {
      this._onClickHeaderButton.next(value);
    }
  }

  public get onClickRefreshButton() {
    return this._onClickRefreshButton.asObservable();
  }

  public set triggerClickRefreshButton(value: boolean) {
    if (value === true) {
      this._onClickRefreshButton.next(value);
    }
  }

  public get onSubmit() {
    return this._onSubmit.asObservable();
  }

  public set triggerSubmit(value: boolean) {
    if (value === true) {
      this._onSubmit.next(value);
    }
  }

  public get onDismiss() {
    return this._onDismiss.asObservable();
  }

  public set triggerDismiss(value: boolean) {
    if (value === true) {
      this._onDismiss.next(value);
    }
  }

  public get onDelete() {
    return this._onDelete.asObservable();
  }

  public set triggerDelete(value: boolean) {
    if (value === true) {
      this._onDelete.next(value);
    }
  }
}
